<template>
  <div v-if="loaded">
    <h5>{{ courrier_type.nom }}</h5>
    <b-row>
      <template v-if="editMode">
        <b-col lg="6">
          <b-row>
            <mh-input mhClass="col-4" field="date" :table="courrier">
            </mh-input>
            <mh-input mhClass="col-4" field="type_envoiID" :table="courrier">
            </mh-input>
            <mh-input
              @change="load()"
              mhClass="col-4"
              field="langue"
              :table="courrier"
            >
            </mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_nom_soc"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_titre"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_prenom"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_nom"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_rue1"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-6"
              field="courrier_rue2"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-4"
              field="courrier_codepostal"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-4"
              field="courrier_localite"
              :table="courrier"
            ></mh-input>
            <mh-input
              mhClass="col-4"
              field="courrier_pays"
              :table="courrier"
            ></mh-input>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <mh-input
                rows="30"
                v-if="courrier.content"
                nolabel
                labelColsLg="0"
                field="content"
                :table="courrier"
              ></mh-input>
            </b-col>
          </b-row>
        </b-col>
      </template>
      <b-col lg="12" class="mt-2">
        <b-button v-if="!editMode" @click="editMode = true" size="sm"
          >Éditer le contenu du courrier</b-button
        >
        <b-button v-else @click="editMode = false" size="sm"
          >Cacher le contenu du courrier</b-button
        >
        <b-button v-if="editMode" class="ml-3" size="sm" @click="previewPdfPath()"
          >Rafraîchir</b-button
        >
        <b-button
          class="ml-3"
          @click="saveCourrier()"
          variant="success"
          size="sm"
          >Confirmer</b-button
        >
        <object
          class="mt-4"
          v-if="pdfPath"
          style="width: 100%; height: 1000px"
          :data="pdfPath"
          type="application/pdf"
        ></object>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import courriers from "@/services/courriers";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "Courrier",
  components: {
    MhInput,
  },
  props: {
    mandat: Object,
    courrier_typeID: [String, Number],
  },
  data() {
    return {
      warrant: {},
      courrier: {},
      courrier_type: {},
      body: "",
      pdfPath: null,
      editMode: false,
      loaded: false,
    };
  },
  created() {
    this.warrant = this.$props.mandat;
    this.courrier = this.warrant.debiteur_courrier;
    this.courrier.content = {};
    this.courrier.courrier_typeID.value = this.$props.courrier_typeID;
    this.courrier_type = this.warrant.courriers_type.filter(
      (x) => x.ID == this.courrier.courrier_typeID.value
    )[0];
    this.load();
  },
  methods: {
    saveCourrier() {
      this.courrier.nom.value = this.courrier_type.nom;
      courriers.create(this.courrier).then(() => {
        this.$emit("close");
      });
    },
    load() {
      courriers
        .getPreviewHTML(this.$props.courrier_typeID, this.courrier)
        .then((response) => {
          this.courrier.content = response.data.content;
          this.loaded = true;
          this.previewPdfPath();
        });
    },
    previewPdfPath() {
      courriers
        .getPreviewPDF(this.$props.courrier_typeID, this.courrier)
        .then((response) => {
          this.pdfPath = "data:application/pdf;base64," + response.data + "#zoom=100";
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>